export default "__VITE_ASSET__uivyAu1h__"